import * as Apollo from "@apollo/client";

import { gql } from "@apollo/client";
import type * as Types from "../../../generated/graphqlBaseTypes";

const defaultOptions = {} as const;
export type GenerateRegexPatternMutationVariables = Types.Exact<{
  input: Types.GenerateRegexPatternInput;
}>;

export type GenerateRegexPatternMutation = { generateRegexPattern: { pattern: string } };

export const GenerateRegexPatternMutationDocument = gql`
    mutation GenerateRegexPatternMutation($input: GenerateRegexPatternInput!) {
  generateRegexPattern(input: $input) {
    pattern
  }
}
    `;
export type GenerateRegexPatternMutationFn = Apollo.MutationFunction<
  GenerateRegexPatternMutation,
  GenerateRegexPatternMutationVariables
>;

/**
 * __useGenerateRegexPatternMutation__
 *
 * To run a mutation, you first call `useGenerateRegexPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRegexPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRegexPatternMutation, { data, loading, error }] = useGenerateRegexPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRegexPatternMutation(
  baseOptions?: Apollo.MutationHookOptions<GenerateRegexPatternMutation, GenerateRegexPatternMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateRegexPatternMutation, GenerateRegexPatternMutationVariables>(
    GenerateRegexPatternMutationDocument,
    options,
  );
}
export type GenerateRegexPatternMutationHookResult = ReturnType<typeof useGenerateRegexPatternMutation>;
export type GenerateRegexPatternMutationResult = Apollo.MutationResult<GenerateRegexPatternMutation>;
export type GenerateRegexPatternMutationOptions = Apollo.BaseMutationOptions<
  GenerateRegexPatternMutation,
  GenerateRegexPatternMutationVariables
>;
